// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Ys8Z","error":"Textarea_error__PNq5J","readonly":"Textarea_readonly__1L1Nd","disabled":"Textarea_disabled__OtZnr"};